export const authLogin = "/auth/login";
